import { render, staticRenderFns } from "./RequestHappiness.vue?vue&type=template&id=05d142d4&scoped=true&"
import script from "./RequestHappiness.vue?vue&type=script&lang=js&"
export * from "./RequestHappiness.vue?vue&type=script&lang=js&"
import style0 from "./RequestHappiness.vue?vue&type=style&index=0&id=05d142d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d142d4",
  null
  
)

export default component.exports